module.exports = __webpack_public_path__ + "img/europe.4e92241.svg";